function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.125 18.125C18.125 18.4565 17.9933 18.7745 17.7589 19.0089C17.5245 19.2433 17.2065 19.375 16.875 19.375H3.125C2.79348 19.375 2.47554 19.2433 2.24112 19.0089C2.0067 18.7745 1.875 18.4565 1.875 18.125V1.875C1.875 1.54348 2.0067 1.22554 2.24112 0.991117C2.47554 0.756696 2.79348 0.625 3.125 0.625H11.9825C12.3138 0.625071 12.6315 0.756651 12.8658 0.990833L17.7592 5.88417C17.9933 6.1185 18.1249 6.43621 18.125 6.7675V18.125Z",
  stroke: "#333333",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.125 6.875H13.125C12.7935 6.875 12.4755 6.7433 12.2411 6.50888C12.0067 6.27446 11.875 5.95652 11.875 5.625V0.625",
  stroke: "#333333",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.16667 9.66168C5.34714 9.89872 5.5821 10.0888 5.85163 10.2157C6.12116 10.3426 6.41731 10.4027 6.715 10.3909C7.66417 10.3909 8.43417 9.81335 8.43417 9.10168C8.43417 8.39002 7.66667 7.81335 6.71833 7.81335C5.77 7.81335 5 7.23585 5 6.52335C5 5.81085 5.77 5.23418 6.71833 5.23418C7.01605 5.22212 7.31228 5.28211 7.58184 5.40906C7.85141 5.536 8.08634 5.72616 8.26667 5.96335",
  stroke: "#333333",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.71826 10.3908V11.25",
  stroke: "#333333",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.71826 4.375V5.23417",
  stroke: "#333333",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M10 12.5H15",
  stroke: "#333333",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M5.625 16.25H15",
  stroke: "#333333",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgInvoice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.11806cdd.svg";
export { ForwardRef as ReactComponent };